module.exports = __webpack_public_path__ + "static/media/virtualmirrorVNActive.f04a30c6.png";